import { useCallback } from 'react';
import { Checkbox } from '../../../../input/Checkbox';
import { Typography } from '../../../../typography/Typography';
import { Column } from '../../styles';
import { Row } from './styles';
import { ContentPromotionGoalsDialogRowProps } from './types';

export const ContentPromotionGoalsDialogRow: React.FC<ContentPromotionGoalsDialogRowProps> = ({
    goal,
    selected,
    onSelect,
}) => {
    const onToggleSelected = useCallback(() => onSelect(!selected), [selected, onSelect]);

    return (
        <Row py={2} px={3}>
            <Column>
                <Checkbox checked={selected} onChange={onToggleSelected} />
            </Column>
            <Column textDecoration="none" flexGrow={1} onClick={onToggleSelected}>
                <Typography variant="body" lines={2} wordBreak="break-word">
                    {`${goal.id} • ${goal.name}`}
                </Typography>
            </Column>
        </Row>
    );
};
